import { render, staticRenderFns } from "./ProfilePassword.vue?vue&type=template&id=4e7fd703&scoped=true"
import script from "./ProfilePassword.vue?vue&type=script&lang=js"
export * from "./ProfilePassword.vue?vue&type=script&lang=js"
import style0 from "./ProfilePassword.vue?vue&type=style&index=0&id=4e7fd703&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7fd703",
  null
  
)

export default component.exports